import React from "react";
import moment from "moment";
import {Modal,Button,PanelGroup,Panel} from "react-bootstrap";
import menu from "../conf/menu"
import AccountingRequestListComponent from "./helper_components/AccountingRequestListComponent";
import CostPhotoListComponent from "./helper_components/CostPhotoListComponent";
import {pdfDownload} from "../redux/actions/cost";
import PaginationComponent from "./helper_components/PaginationComponent";
import tableExport from "tableexport";
import filterValue from "../conf/words";
import CostImagePopup from "./helper_components/CostImagePopup";
import {checkTokenUtil, mapForObject} from "../utils";
import ExchangeRateModalComponent from "./helper_components/ExchangeRateModalComponent";
import LoadingComponent from "./helper_components/LoadingComponent";
const createReactClass = require('create-react-class');

tableExport.prototype.xlsx = {
    defaultClass: "xlsx",
    buttonContent: "Export to xlsx",
    mimeType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    fileExtension: ".xlsx"
};

const AccountingComponent = createReactClass({
  getInitialState: function(){
    return {
      isVisibleModal:false,
      isVisibleModalSumiagro: false,
      detail:{
        user:{},
        request:{}
      },
      startPageNumber: 0,
      endPageNumber: 5,
      pageNumberToShow:5,
      activePage:1,
      numberOfPage:10,
      transactionModal:false,
      revisionsModal:false,
      showExchangeRateModal:false,
      img:{
        show:false,
        src:""
      },
  };
  },
  closeRevisionsModal(){
    const formType = this.state.detail.request.formType;
    if(formType === "applicationSumiagro" || formType === "settlementSumiagro"){
      this.setState({
        revisionsModal:false,
        isVisibleModalSumiagro:true
      })
    }else{
      this.setState({
        revisionsModal:false,
        isVisibleModal:true
      })
    }
  },
  closeAction: function(){
    this.setState({
      isVisibleModal:false,
      isVisibleModalSumiagro:false
    });
  },
  infoButton:function(user,request){
    if(request.formType === "applicationSumiagro" || request.formType === "settlementSumiagro"){
      this.setState({isVisibleModalSumiagro:true})
    }else{
      this.setState({isVisibleModal:true})
    }
    this.setState({
      detail:{
        user:user,
        request:request
      }
    });
  },
  exchangeRateButton:function(user,request){    
    this.setState({
      showExchangeRateModal:true,
      detail:{
        user:user,
        request:request
      }
    });
  },
 
  componentDidUpdate(prevProps,prevState){
    const result = checkTokenUtil()
  },
  componentDidMount: async function(){

      await this.props.getAccountingRequest(this.props.accessToken,this.props.filter.employee ? this.props.filter.employee:"-1",this.refs.month.value,this.refs.year.value)
  },
  accountingRequestConfirmButton:function(bool = false,user,costData){
    if(bool) {
      this.props.confirmAllCostsButtonAction(this.props.accessToken,this.props.filter.employee,this.refs.month.value,this.refs.year.value);
    }else {
      this.props.accountingRequestConfirmAction(costData, this.props.accessToken, this.closeAction);
    }
  },
  accountingRequestCancelButton:function(user,costData){
    this.props.accountingRequestCancelAction(costData,this.props.accessToken,this.closeAction);
  },
  accountingRequestUpdateExchangeRateButton: function(user, costData){
    this.props.accountingRequestUpdateExchageRateAction(costData,this.props.accessToken,this.closeAction);
  },
  pdfDownloadButton:function(user,costData){
    pdfDownload(user,costData,this.props.accessToken);
  },
  setFilterAction:async function(filterValue){
    this.setState({
      activePage:1
    })
      await this.props.getAccountingRequest(this.props.accessToken,filterValue.employee,filterValue.month,filterValue.year)
      await this.props.setFilter(filterValue);
  },
  pagination:function(){
    var {activePage,numberOfPage} = this.state;
    var {accountingRequestList} = this.props;
    var pageIndex = (activePage * numberOfPage) - numberOfPage;
    var pageTotal = accountingRequestList.length - (activePage * numberOfPage);
    if(pageTotal < 0){
      pageTotal = accountingRequestList.length;
    }else{
      pageTotal = pageIndex + numberOfPage;
    }
    return {
      totalPage: Math.ceil(accountingRequestList.length / numberOfPage),
      start:pageIndex,
      finish:pageTotal
    }
  },
  costImagePopupShow:function(src){
    this.setState({
      img:{
        show:true,
        src:src
      }
    })
  },
  render:function(){
    var {accountingRequestList,filter,employees,isLoading, t} = this.props;
    var {user,request} = this.state.detail;
    request.costPhotos = (request.costPhotos ? request.costPhotos : []);
    var context = this;
    document.title = t(menu[this.props.location.pathname])+" - masraf.dakika.com.tr";
    var year = [];
    for(var i = window.costStartingYear;i<=new Date().getFullYear();i++){
      year.push(<option key={i} value={i}>{i}</option>);
    }
    let employeeFilterDefaultValue =  filter.employee;
    var {totalPage,start,finish} = this.pagination();
    if(!request.revisions)
      request.revisions = [];
    return (
      <div className="content">
        {
          /*
            Cost Image Popup
          */
        }
        <CostImagePopup t={t} closeButton={() => {
            this.setState({
              img:{
                show:false,
                src:""
              }
            })
          }} show={this.state.img.show} src={this.state.img.src}/>
            <Modal show={this.state.isVisibleModalSumiagro}>
          <Modal.Header closeButton onHide={this.closeAction}>
            <Modal.Title id="contained-modal-title">{t("costDetail")}/ <span className="costForUsername">{(user.employees ? user.employees.employeeName : null)}</span></Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <table className="table table-hover table-bordered">
              <tbody>
                <tr>
                  <td>{t("costDate")}</td>
                  <td><span>{request.costDate}</span></td>
                </tr>
                <tr>
                  <td>{t("invoiceReceiptNo")}</td>
                  <td><span>{request.invoiceNo}</span></td>
                </tr>
                <tr>
                  <td>{t("costType")}</td>
                  <td><span>{request.costType}</span></td>
                </tr>
                {
                  request.formType === "settlementSumiagro" ? (
                    <>
                      <tr>
                        <td>{t("preApprovedBudget")}</td>
                        <td><span>{request.preApprovedBudget}</span></td>
                      </tr>
                      <tr>
                        <td>{t("actualExpenditure")}</td>
                        <td><span>{request.costAmount}</span></td>
                      </tr>
                    </>
                  ) : (
                      <tr>
                          <td>{t("costAmount")}</td>
                          <td><span>{request.costAmount}</span></td>
                      </tr>
                  )
                }           
                <tr>
                      <td>{t("company")}</td>
                      <td><span>{request.companyName}</span></td>
                </tr>
                <tr>
                      <td>{t("place")}</td>
                      <td><span>{request.placeName}</span></td>
                </tr>              
                <tr>
                      <td>{t("guests")}</td>
                      <td><span>{request.guestName}</span></td>
                </tr>
                <tr>
                      <td>{t("guestNumber")}</td>
                      <td><span>{request.guestNumber}</span></td>
                </tr>
                <tr>
                      <td>{t("staff")}</td>
                      <td><span>{request.staffName}</span></td>
                </tr>
                <tr>
                      <td>{t("staffNumber")}</td>
                      <td><span>{request.staffNumber}</span></td>
               </tr>
                <tr>
                      <td>{t("otherParticipants")}</td>
                      <td><span>{request.otherParticipant}</span></td>
                </tr>
                <tr>
                      <td>{t("otherParticipantNumber")}</td>
                      <td><span>{request.otherParticipantNumber}</span></td>
                </tr>
                <tr>
                  <td>{t("currencyUnit")}</td>
                  <td><span>{request.moneyType}</span></td>
                </tr>
                <tr>
                  <td>{t("paymentType")}</td>
                  <td><span>{request.paymentType}</span></td>
                </tr>
                <tr>
                  <td>{t("supplierName")}</td>
                  <td><span>{request.supplierName}</span></td>
                </tr>
                <tr>
                  <td>{t("description")}</td>
                  <td><span>{request.costDescription}</span></td>
                </tr>
                <tr>
                  <td>{t("photos")}</td>
                  <td><div className="row">
                    {
                      request.costPhotos.length > 0
                      ?
                        request.costPhotos.map((d,k) => {
                          return <CostPhotoListComponent t={t} costImagePopupShow={(src) => {this.costImagePopupShow(src)}} photo={d} key={k}/>
                        })
                      :
                      <h6 className="title" style={{paddingLeft:"10px"}}>{t("photoIsNotUploadded")}</h6>
                    }
                  </div></td>
                </tr>
                {
                  request.status == "accountingCancel"
                  ?
                  <tr>
                    <td>{t("reasonForCancellation")}: </td>
                    <td><span className="cancelText">{request.costCancelDescription}</span></td>
                  </tr>
                  :
                  null
                }
              </tbody>
           </table>
          </Modal.Body>
          <Modal.Footer>
            <div className="row">
                <div className="col-md-2">
                { request.revisions && request.revisions.length > 0
                ?  
                <Button className="btn btn-warning btn-fill btn-wd" onClick={() => {
                    this.setState({
                      revisionsModal:true,
                      isVisibleModalSumiagro:false
                    })
                  }}>{t("revisions")}</Button>
                  : null
                }
                </div>
              <div className="col-md-10">
                {
                  request.status == "accounting"
                  ?
                  <div style={{display:"inline-block"}}>
                    <Button onClick = {() => {this.accountingRequestConfirmButton(false,user,request)}} className="btn btn-wd btn-success"><span className="btn-label"><i className="fa fa-check"></i></span> {t("approveCost")}</Button>
                    <Button onClick = {() => {this.accountingRequestCancelButton(user,request)}} className="btn btn-wd btn-danger"><span className="btn-label"><i className="fa fa-times"></i></span>{t("rejectCost")}</Button>
                  </div>
                  :
                  null
                }
              </div>
            </div>
          </Modal.Footer>
        </Modal>
      
        <Modal show={this.state.isVisibleModal}>
          <Modal.Header closeButton onHide={this.closeAction}>
            <Modal.Title id="contained-modal-title">{t('costDetail')} / <span className="costForUsername">{(user.employees ? user.employees.employeeName : null)}</span></Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <table className="table table-hover table-bordered">
              <tbody>
                <tr>
                  <td>{t('costDate')}</td>
                  <td><span>{moment(request.costDate).format('DD/MM/YYYY')}</span></td>
                </tr>
                <tr>
                  <td>{t('invoiceNo')}</td>
                  <td><span>{request.invoiceNo}</span></td>
                </tr>
                <tr>
                  <td>{t('costType')}</td>
                  <td><span>{request.costType}</span></td>
                </tr>
                <tr>
                  <td>{t('costAmount')}</td>
                  <td><span>{request.costAmount}</span></td>
                </tr>
                <tr>
                  <td>{t('currencyUnit')}</td>
                  <td><span>{request.moneyType}</span></td>
                </tr>
                <tr>
                  <td>{t('paymentType')}</td>
                  <td><span>{request.paymentType}</span></td>
                </tr>
                <tr>
                  <td>{t('supplierName')}</td>
                  <td><span>{request.supplierName}</span></td>
                </tr>
                <tr>
                  <td>{t('description')}</td>
                  <td><span>{request.costDescription}</span></td>
                </tr>
                <tr>
                  <td>{t('photos')}</td>
                  <td><div className="row">
                    {
                      request.costPhotos.length > 0
                      ?
                        request.costPhotos.map((d,k) => {
                          return <CostPhotoListComponent t={t} costImagePopupShow={(src) => {this.costImagePopupShow(src)}} photo={d} key={k}/>
                        })
                      :
                      <h6 className="title" style={{paddingLeft:"10px"}}>{t('photoIsNotUploadded')}</h6>
                    }
                  </div></td>
                </tr>
                {
                  request.status == "accountingCancel"
                  ?
                  <tr>
                    <td>{t('reasonForCancellation')}: </td>
                    <td><span className="cancelText">{request.costCancelDescription}</span></td>
                  </tr>
                  :
                  null
                }
              </tbody>
           </table>
          </Modal.Body>
          <Modal.Footer>
            <div className="row">
                <div className="col-md-2">
                { request.revisions && request.revisions.length > 0
                ?  
                <Button className="btn btn-warning btn-fill btn-wd" onClick={() => {
                    this.setState({
                      revisionsModal:true,
                      isVisibleModal:false
                    })
                  }}>{t('revisions')}</Button>
                  : null
                }
                </div>
              <div className="col-md-10">
                {
                  request.status == "accounting"
                  ?
                  <div style={{display:"inline-block"}}>
                    <Button onClick = {() => {this.accountingRequestConfirmButton(false,user,request)}} className="btn btn-wd btn-success"><span className="btn-label"><i className="fa fa-check"></i></span> {t('approveCost')}</Button>
                    <Button onClick = {() => {this.accountingRequestCancelButton(user,request)}} className="btn btn-wd btn-danger"><span className="btn-label"><i className="fa fa-times"></i></span>{t('rejectCost')}</Button>
                  </div>
                  :
                  null
                }
              </div>
            </div>
          </Modal.Footer>
        </Modal>
        {
          /*
            Revize Modal
          */
        }
        <Modal show={this.state.revisionsModal}>
          <Modal.Header closeButton onHide={() => {
              this.setState({
                revisionsModal:false
              })
            }}>
            <Modal.Title id="contained-modal-title">{t('revisions')} / <span className="costForUsername" dangerouslySetInnerHTML={{__html: t('totalRevision',{length: request.revisions ? request.revisions.length : null})}} ></span></Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <PanelGroup>
              {
                request.revisions.length > 0
                ?
                request.revisions.map((fields,key) => {
                  return (
                    <Panel key={key} collapsible header={fields.date} eventKey={key}>
                      <table className="table table-hover table-bordered">
                        <tbody>
                          {
                            Object.keys(fields.fields).length > 0
                            ?
                              mapForObject(fields.fields,(data,index,key2) => {
                                var nextData = [];
                                var incrementKey = key+1;
                                while(incrementKey < request.revisions.length){
                                  nextData = mapForObject(request.revisions[incrementKey].fields,index);
                                  if(typeof nextData != "object")
                                    break;
                                  incrementKey++;
                                }
                                if(typeof nextData === "object")
                                  nextData = request[index];
                                return (
                                  <tr key={key2}>
                                    <td>{t(filterValue.costFields[index])}</td>
                                    <td><strong className="darkred">{data}</strong> / <strong className="green">{nextData}</strong></td>
                                  </tr>
                                )
                              })
                            :
                            <tr>
                              <td>{t('notUpdatedData')}</td>
                            </tr>
                          }
                        </tbody>
                     </table>
                    </Panel>

                  )
                })
                :
                null
              }
            </PanelGroup>
          </Modal.Body>
          <Modal.Footer style={{textAlign:"left"}}>
            <button type="button" onClick={() => this.closeRevisionsModal()} className="btn btn-wd btn-default"><span className="btn-label"><i className="fa fa-arrow-left"></i></span>{t('back')}</button>
          </Modal.Footer>
        </Modal>
        {
          /*
            İşlem Modal
          */
        }
        <Modal show={this.state.transactionModal}>
          <Modal.Header closeButton onHide={() => {
              this.setState({
                transactionModal:false
              })
            }}>
            <Modal.Title id="contained-modal-title">{t('transactions')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <PanelGroup>
              {
                request.transactions
                ?
                request.transactions.map((fields,key) => {
                  return (
                    <Panel style={{padding: "10px 10px 0px 10px"}} key={key} collapsible header={fields.transactionDate+" - "+ fields.employeeName} eventKey={key}>
                      <p className="p">
                        <strong className="employeeName">{fields.employeeName}, </strong>
                        <span dangerouslySetInnerHTML={{
                          __html: t('approvedRejectedDate',
                          {
                            date:fields.transactionDate,
                            time:fields.transactionTime,
                            transactionType: fields.transactionType == 1 ? t('approvedTransactions') : t('rejectedTransactions')
                          })}}></span>
                      </p>
                    </Panel>
                  )
                })
                :
                null
              }
            </PanelGroup>
          </Modal.Body>
        </Modal>
        {this.state.showExchangeRateModal ?
         <ExchangeRateModalComponent
         t={t}
         recordedExchangeRate = {this.state.detail.request}
         isShown = {this.state.showExchangeRateModal}
        
         setIsShowFalse = {() => this.setState({showExchangeRateModal:false})}
       />:
       null
        }
       

     <div className="container-fluid">
          <div className="row">
              <div className="col-xs-12">
                  <div className="card">
                      <div className="content">
                        <div className="row">
                          <div className="col-md-3">
                            <select defaultValue={employeeFilterDefaultValue} ref="employees" onChange={(e) => {
                                this.setFilterAction({
                                  status: "accounting",
                                  month: this.refs.month.value,
                                  year:this.refs.year.value,
                                  employee:e.target.value
                                })
                              }} className="form-control input-sm border-input filterSelect">
                              <option value="-1">{t('all')}</option>
                              {
                               employees ?  employees.map((employee,index) => <option key={index} value={employee._id}>{employee.employeeName}</option>)
                                : null
                              }
                            </select>
                          </div>
                            <div className="col-md-2">
                              <select ref="month" onChange={(e) => {
                                  this.setFilterAction({
                                    status: "accounting",
                                    month: e.target.value,
                                    year:this.refs.year.value,
                                    employee:this.refs.employees.value
                                  })
                                }} defaultValue={filter.month} className="form-control input-sm border-input filterSelect">
                                 <option value="-1">{t('selectMonth')}</option>
                                <option value="01">{t('jan')}</option>
                                <option value="02">{t('feb')}</option>
                                <option value="03">{t('mar')}</option>
                                <option value="04">{t('apr')}</option>
                                <option value="05">{t('may')}</option>
                                <option value="06">{t('jun')}</option>
                                <option value="07">{t('jul')}</option>
                                <option value="08">{t('aug')}</option>
                                <option value="09">{t('sep')}</option>
                                <option value="10">{t('oct')}</option>
                                <option value="11">{t('nov')}</option>
                                <option value="12">{t('dec')}</option>
                              </select>
                            </div>
                            <div className="col-md-2">
                              <select ref="year" onChange={(e) => {
                                  this.setFilterAction({
                                    status: "accounting",
                                    month: this.refs.month.value,
                                    year:e.target.value,
                                    employee:this.refs.employees.value
                                  })
                                }} defaultValue={filter.year} className="form-control input-sm border-input filterSelect">
                                <option value="-1">{t('selectYear')}</option>
                                {year}
                              </select>
                            </div>
                        </div>
                      </div>
                  </div>
              </div>
          </div>
            <div className="row">
                <div className="col-lg-12 col-md-12">
                    <div className="card costList">
                        <div className="header">
                            <h4 className="title">{t('expenses')}</h4>
                        </div>
                        <div className="content">
                          <div className="content table-responsive table-full-width">
                              {
                                  isLoading ?
                                      <LoadingComponent type={"bars"} color={'#3298e9'} name={" Bu işlem biraz uzun sürebilir. Lütfen bekleyin..."}/>
                                      :
                                      <table className="table table-striped">
                                          <thead>
                                          <tr>
                                              <th>{t('employee')}</th>
                                      <th>{t('invoice')}</th>
                                      <th>{t('costType')}</th>
                                      <th>{t('costDate')}</th>
                                      <th>{t('creationDate')}</th>
                                      <th>{t('amount')}</th>
                                      <th></th>
                                          </tr>
                                          </thead>
                                          <tbody id="accountingRequestList">
                                          {
                                              accountingRequestList.length > 0
                                                  ?
                                                  accountingRequestList.slice(start,finish).map((cost,key) => {
                                                
                                                    return <AccountingRequestListComponent t={t} key={key} transactionsButton={(user,data) => {this.setState({transactionModal:true,detail:{user:user,request:data}})}}  pdfDownloadButton={this.pdfDownloadButton} buttonsActions={[this.accountingRequestConfirmButton,this.accountingRequestCancelButton]} photoDelete="false" infoButton={this.infoButton} exchangeRateButton={this.exchangeRateButton} data={cost.costs} user={cost.user} parent={context}/>
                                     
                                      })
                                      :
                                      null
                                    }
                                    {
                                      accountingRequestList.length > 0 && filter.status == "accounting"
                                      ?
                                      <tr>
                                        <td colSpan="7" style={{textAlign:"center"}}>
                                          <button id="accountingConfirmationConfirmAll" onClick = {() => {this.accountingRequestConfirmButton(true)}} type="button" style={{minWidth:"30%"}} className="btn btn-wd btn-success">
                                            <span className="btn-label"><i className="fa fa-check"></i></span>
                                              {t('approveAll')}
                                          </button>
                                        </td>
                                      </tr>
                                      :
                                      null
                                    }
                                  </tbody>
                              </table>
                              }
                          </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card">
              <div className="content">
                <PaginationComponent t={t} totalPage={totalPage} endPageNumber={this.state.endPageNumber} startPageNumber={this.state.startPageNumber} pageNumberToShow={this.state.pageNumberToShow} parent={this} activePage={this.state.activePage} numberOfPage={this.state.numberOfPage}  data={accountingRequestList}/>
              </div>
            </div>
        </div>
    </div>
    )
  }
});

export default AccountingComponent;
